/* Imports happen in Gulp */
var stylesheet = loadCSS(document.getElementById("loadcss"));
onloadCSS( stylesheet, function() {

  //Webfonts
  var WebFontConfig = {
    custom: {
      families: [
        'Font Awesome 5 Free',
        'Font Awesome 5 Brands',
        'PT Sans'
      ],

      urls: [LoadFonts]
    }
  };
  WebFont.load(WebFontConfig);

  //FAQ
  $('.collapse').on('shown.bs.collapse', function(){
    $(this).parent().find(".fa-plus").removeClass("fa-plus").addClass("fa-minus");
    }).on('hidden.bs.collapse', function(){
    $(this).parent().find(".fa-minus").removeClass("fa-minus").addClass("fa-plus");
  });

  //Lazyload background images
  document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });

  //Mobile Utilities
  function mobileAdjustments(){
    var sm = window.matchMedia("(max-width: 576px)");
    var md = window.matchMedia("(max-width: 768px)");
    var lg = window.matchMedia("(max-width: 992px)");
    var xl = window.matchMedia("(max-width: 1200px)");
    var xxl = window.matchMedia("(max-width: 1400px)");

    if(lg.matches){
      $('.zoek-form').appendTo('.megamenu-navigation');
    } else {
      $('.zoek-form').insertBefore('.toggle-zoek-form');
    }
  }

  $(document).ready(function(){

    mobileAdjustments();
    $(window).on('resize', function(){
      mobileAdjustments();
    });

    //Enable tooltips
    $('[data-toggle="tooltip"]').tooltip({container: 'body'});

    //Scrollbars
    //$('body').overlayScrollbars();

    if($('.show-modal').length != false){
      $('.show-modal').closest('.modal').modal('show');
    }

    $(".animsition").animsition({
        inClass: 'fade-in',
        outClass: 'fade-out',
        inDuration: 1000,
        outDuration: 300,
        linkElement: '.animsition-link',
        loading: true,
        loadingParentElement: 'body',
        loadingClass: 'animsition-loading',
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: [ 'animation-duration', '-webkit-animation-duration'],
        overlay : false,
        overlayClass : 'animsition-overlay-slide',
        overlayParentElement : 'body',
        transition: function(url){ window.location.href = url; }
    });

    if($('.banner--slider').length != false){
      if(!$('.banner--slider').hasClass('swiper-container-initialized')){
        new Swiper('.banner--slider', {
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: '.slide-next',
            prevEl: '.slide-prev'
          }
        });
      }
    }

    if($('.slides--slider').length != false){
      if(!$('.slides--slider').hasClass('swiper-container-initialized')){
        new Swiper('.slides--slider', {
          slidesPerView: 4,
          loop: true,
          navigation: {
            nextEl: '.slide-next',
            prevEl: '.slide-prev'
          }
        });
      }
    }
  });

  //$(window).on("load", function(e) {
  //  if ($('.banner-video-html')) {
  //      var t = $('.banner-video-html');
  //      $(window).width() > 992 && t.play(), t.oncanplaythrough = function() {
  //          $(".posterImage").fadeOut(250)
  //      }
  //  }
  //});

	$(".toggle-zoek-form").click(function() {
		$(".zoek-form").toggleClass('zoek-form-weergeven');
		$(".toggle-zoek-form .fa").toggleClass('fa-seach');
    $(".toggle-zoek-form .fa").toggleClass('fa-times');
    $(".zoek-form .zoek-form--fields input").focus();
	});


});
